export default __webpack_public_path__ + "e40e1a4119b0effa22994c301ee5bd9d.png";